import React from 'react';
import { T } from 'shared/helper/translate';
import PlanPill from './PlanPill';
var PlanCard = function PlanCard(_ref) {
  var title = _ref.title,
    popularBadge = _ref.popularBadge,
    pill = _ref.pill,
    price = _ref.price,
    period = _ref.period,
    savingsNote = _ref.savingsNote,
    featuresPrefix = _ref.featuresPrefix,
    featuresTerm = _ref.featuresTerm,
    action = _ref.action;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-card position-relative d-flex flex-column"
  }, popularBadge && /*#__PURE__*/React.createElement("span", {
    className: "pricing-popular-badge position-absolute top-0 translate-middle-y rounded-pill fw-bold text-uppercase text-nowrap"
  }, popularBadge), /*#__PURE__*/React.createElement("div", {
    className: "pricing-card-header"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "pricing-card-title fw-bold mb-2"
  }, title), pill && /*#__PURE__*/React.createElement(PlanPill, null, pill)), /*#__PURE__*/React.createElement("div", {
    className: "pricing-price-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-baseline gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pricing-price fw-bold lh-1"
  }, price), period && /*#__PURE__*/React.createElement("span", {
    className: "pricing-period fw-semibold"
  }, period)), savingsNote && /*#__PURE__*/React.createElement("p", {
    className: "pricing-savings fw-bold"
  }, savingsNote)), /*#__PURE__*/React.createElement("div", {
    className: "pricing-features flex-grow-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "pricing-features-prefix fw-bold"
  }, featuresPrefix), /*#__PURE__*/React.createElement("div", {
    className: "pricing-feature-list"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: featuresTerm
  }))), action);
};
export default PlanCard;